module.exports = __webpack_public_path__ + "static/WEDDING E&M-462-e4c4ae0ae7871ae85774b8c6dadc395a.jpg";